module.exports = __webpack_public_path__ + "images/emoji/small_orange_diamond.d618ce84fc8fa9b1d3ff.png";